import { render, staticRenderFns } from "./BankHelpList.vue?vue&type=template&id=44603a51&"
import script from "./BankHelpList.vue?vue&type=script&lang=js&"
export * from "./BankHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports